export enum KycStatus {
  NotStarted = 1,
  Completed = 2,
  Failed = 3,
  Rejected = 4,
  Approved = 5,
  Expired = 6,
}

export interface KycResponse {
  statusId: KycStatus;
}
